<template>
<div>
  <a @click="afficherDetail" class="iconArrowMenu"
    :class="{'iconRecouvrementArrowMenuOpen': isDetailAffiche}">
    <b-icon
      icon="arrow-right-drop-circle"
      type="is-default">
    </b-icon>
  </a>
  <div class="card mgr-10px" v-if="isDetailAffiche">
    <div class="card-content">
      <detail-lignes-commande
        :masqueRemise="false"
        :isEditPrevisu="false"
        :isPrevisualisation="false"
        :typeDCF="typeCommande()"
        :lignes-commande="detailCommande.lignesCommande"
        :afficherLien="afficherLien"
        @masqueLigneChange="$emit('masqueLigneChange', $event)"
        @masqueRemiseChange="$emit('masqueRemiseChange', $event)"/>
    </div>
  </div>
</div>
</template>

<script>
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import { get as getCommande } from '@/api/commande/index';
import detailLignesCommande from '@/components/devisCommandes/detailDevisCommande/detailLignesCommande';
import * as devisConf from '@/configuration/devisConf';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    commandeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      detailCommande: null,
      afficherLien: null,
    };
  },
  components: {
    detailLignesCommande,
  },
  computed: {
    isDetailAffiche() {
      return this.detailCommande !== null;
    },
  },
  methods: {
    async afficherDetail() {
      if (this.detailCommande === null) {
        await this.getDetailCommande();
      } else {
        this.detailCommande = null;
      }
    },
    typeCommande() {
      return devisConf.TYPE_COMMANDE;
    },
    async getDetailCommande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const commande = await getCommande(this.commandeId);
        this.afficherLien = this.checkIfCurrentSociety(commande.data.result.societeId);
        this.detailCommande = detailDevisCommande(commande.data.result);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
};
</script>

<style scoped>

</style>
